import { Component, OnInit, Inject } from '@angular/core';
import { Validators, FormGroup, FormControl, FormBuilder} from '@angular/forms';
import { Router } from '@angular/router';
import {HttpService} from '../http.service';
import {MatDialog, MatDialogRef, MAT_DIALOG_DATA} from '@angular/material';


export interface DialogData {
  email: string;
}

@Component({
  selector: 'app-contact',
  templateUrl: './contact.component.html',
  styleUrls: ['./contact.component.css']
})

export class ContactComponent implements OnInit {

  contactForm = this.fb.group({
    name: ['', Validators.required],
    surname: [''],
    status: ['', Validators.required],
    address: [''],
    town: ['', Validators.required],
    zipcode: ['', Validators.required],
    habitants: [''],
    alreadyClient: [''],
    phone: [''],
    email: ['', [Validators.required, Validators.email]],
    optin: ['', Validators.requiredTrue],
    subscribeNews: ['']
  });

  inputContain="name";
  private timeOut;

  constructor( public httpService: HttpService, private fb: FormBuilder,  private router: Router, public dialog: MatDialog) { }

  ngOnInit() {
    this.startTimeOut();
  }


  validContact() {
    //console.log(this.contactForm.value);
    this.controlContact(this.contactForm.value);
  }

  get name() { return this.contactForm.get('name'); }
  get status() { return this.contactForm.get('status'); }
  get town() { return this.contactForm.get('town'); }
  get zipcode() { return this.contactForm.get('zipcode'); }
  get email() { return this.contactForm.get('email'); }

  getEmailErrorMessage() {
    return this.email.hasError('required') ? 'Vous devez renseigner l\'émail' :
      this.email.hasError('email') ? 'L\'émail semble incorrect' :
        '';
  }

  controlContact(data) {
    if (this.contactExist(data.email)) {
      console.log("Vous avez déjà tenté votre chance");
      this.openDialog(data.email);
    } else {
      this.setLocalStorageEmail(data.email);
    }
  }

  contactExist(data: string): boolean {
    var players_emails = JSON.parse(localStorage.getItem("players_emails"));
    if (players_emails!=null) {
      return players_emails.includes(data);
    }
    else {
      localStorage.setItem('players_emails', '[]');
      return false}
  }

  setLocalStorageEmail(data) {
    var players_emails = JSON.parse(localStorage.getItem('players_emails'));
      players_emails.push(data);
      localStorage.setItem('players_emails', JSON.stringify(players_emails));
      clearTimeout(this.timeOut); // nécessaire car angular ne détruit pas le timeOut lorsque l'on navigue par le router
      this.router.navigate(['quiz',this.contactForm.value]);
  }

  postContactForm(data) {
    this.httpService.postContactForm(data);
  }

  openDialog(email): void {
    const dialogRef = this.dialog.open(DialogOverview, {
      width: '450px',
      data: {email: email}
    });

    dialogRef.afterClosed().subscribe(result => {
      console.log('The dialog was closed');
    });
  }

  onInput(event: any) { // without type info
    this.inputContain = event.target.id;
    console.log(this.inputContain);
  }

  onTouch(event: any) { // without type info

    var data = event.target.dataset.value;
    console.log(data);
    if (data=="suppr") {
      var initialDataSliced=this.contactForm.get(this.inputContain).value.toString().slice(0, -1);
      console.log(initialDataSliced);
      this.contactForm.controls[this.inputContain].setValue(initialDataSliced);

    }
    else {
      if (this.inputContain=="habitants" || this.inputContain=="zipcode" ) {
        var reg = new RegExp('^[0-9]+$');
        if (reg.test(data)==true) {
          var initialData=this.contactForm.get(this.inputContain).value;
          this.contactForm.controls[this.inputContain].setValue(initialData+data);
        }
      }
      else {
        var initialData=this.contactForm.get(this.inputContain).value;
        this.contactForm.controls[this.inputContain].setValue(initialData+data);
      }
    }
  }

  startTimeOut(){
    console.log('startTimeOut');
    clearTimeout(this.timeOut);
    this.timeOut = setTimeout(()=>{
      this.router.navigate(['home']);
    }, 120000);
  }
}

@Component({
  selector: 'dialog-overview',
  templateUrl: 'dialog-overview.html',
})
export class DialogOverview {
  constructor(
    public dialogRef: MatDialogRef<DialogOverview>,
    @Inject(MAT_DIALOG_DATA) public data: DialogData) {}
}
